// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__fH0uW","tab":"Tabs_tab__X52T4","selected":"Tabs_selected__66Aie","title":"Tabs_title__xZPcU","subTitle":"Tabs_subTitle__JShri"};